import React from 'react';
import * as S from './OperationsListSkeleton.styles';
import { SkeletonLoader } from '@/components/SkeletonLoader/SkeletonLoader';

interface OperationsListSkeletonProps {
  itemsCount?: number;
  hasContainer?: boolean;
}

const DEFAULT_ITEMS_COUNT = 8;

export function OperationsListSkeleton({
  itemsCount = DEFAULT_ITEMS_COUNT,
  hasContainer = true,
}: OperationsListSkeletonProps) {
  const content = Array.from({ length: itemsCount }).map((_, index) => (
    <S.Item key={index}>
      <S.Content>
        <S.TopRow>
          <SkeletonLoader width="60%" height={18} borderRadius={7} />
          <SkeletonLoader width={80} height={18} borderRadius={7} />
        </S.TopRow>
        <S.BottomRow>
          <SkeletonLoader width={120} height={18} borderRadius={7} />
          <SkeletonLoader width={80} height={18} borderRadius={7} />
        </S.BottomRow>
      </S.Content>
      <SkeletonLoader width={6} height={12} borderRadius={7} />
    </S.Item>
  ));

  return hasContainer ? <S.Container>{content}</S.Container> : content;
}
